<template>
  <el-dialog
    :title="$t('contactInformationText')"
    :visible.sync="dialogVisible"
    width="60%"
    @close="handleClose"
    :append-to-body="true"
  >
    <el-form
      ref="personalDataForm"
      :inline-message="false"
      :inline="true"
      :rules="rules"
      :model="userForm"
      label-width="150px"
      size="small"
      v-loading="loading"
      :status-icon="true"
    >
      <!-- Read-only fields (disabled) -->
      <el-form-item size="small" prop="surname" :label="$t('surname')">
        <el-input v-model="userForm.surname" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="name" :label="$t('name')">
        <el-input v-model="userForm.name" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="fatherName" :label="$t('fname')">
        <el-input v-model="userForm.fatherName" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="motherName" :label="$t('mname')">
        <el-input v-model="userForm.motherName" :disabled="true"></el-input>
      </el-form-item>

      <!-- Hidden fields for future use -->
      <el-form-item prop="gender" :label="$t('gender')" v-show="false">
        <el-select
          class="countries"
          v-model="userForm.gender"
          :disabled="true"
          :placeholder="$t('select')"
        >
          <el-option
            v-for="item in genderOptions"
            :key="item.value"
            :label="$t(item.label)"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <hr v-show="false" />

      <el-form-item prop="birthCountryId" :label="$t('countryofbirth')" v-show="false">
        <el-select
          v-model="userForm.birthCountryId"
          :disabled="true"
          :placeholder="$t('select_country')"
          class="countries"
          filterable
        >
          <el-option
            v-for="country in countries"
            :key="country.id"
            :label="country.name"
            :value="country.id"
          >
            {{
              country.name.length > 30
                ? country.name.substring(0, 28) + '...'
                : country.name
            }}
          </el-option>
        </el-select>
        <div>
          {{
            userForm.birthCountryId &&
            countries.find(country => country.id === userForm.birthCountryId) &&
            countries.find(country => country.id === userForm.birthCountryId)
              .name.length > 30
              ? countries.find(
                  country => country.id === userForm.birthCountryId
                ).name
              : ''
          }}
        </div>
      </el-form-item>

      <el-form-item prop="birthCity" :label="$t('cityofbirth')" v-show="false">
        <el-input v-model="userForm.birthCity" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="dateOfBirth" :label="$t('dateofbirth')" v-show="false">
        <el-input v-model="userForm.dateOfBirth" :disabled="true"></el-input>
      </el-form-item>

      <hr v-show="false" />

      <el-form-item prop="countryId" :label="$t('countryofresidence')" v-show="false">
        <el-select
          v-model="userForm.countryId"
          :disabled="true"
          :placeholder="$t('select_country')"
          class="countries"
          filterable
        >
          <el-option
            v-for="country in countries"
            :key="country.id"
            :label="country.name"
            :value="country.id"
          >
            {{
              country.name.length > 30
                ? country.name.substring(0, 28) + '...'
                : country.name
            }}
          </el-option>
        </el-select>
        <div>
          {{
            userForm.countryId &&
            countries.find(country => country.id === userForm.countryId) &&
            countries.find(country => country.id === userForm.countryId).name.length > 30
              ? countries.find(country => country.id === userForm.countryId).name
              : ''
          }}
        </div>
      </el-form-item>

      <el-form-item prop="address" :label="$t('homeaddress')" v-show="false">
        <el-input v-model="userForm.address" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="postcode" :label="$t('zip')" v-show="false">
        <el-input v-model="userForm.postcode" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="city" :label="$t('city')" v-show="false">
        <el-input v-model="userForm.city" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item prop="area" :label="$t('region')" v-show="false">
        <el-input v-model="userForm.area" :disabled="true"></el-input>
      </el-form-item>

      <hr />

      <!-- Editable fields - Contact Information -->
      <el-form-item prop="telephone" :label="$t('tel')">
        <el-input v-model="userForm.telephone" :disabled="false"></el-input>
      </el-form-item>

      <el-form-item prop="mobile" :label="$t('mobile')">
        <el-input v-model="userForm.mobile" :disabled="false"></el-input>
      </el-form-item>

      <el-form-item prop="email" :label="$t('email')">
        <el-input
          v-model="userForm.email"
          type="email"
          :disabled="false"
        ></el-input>
      </el-form-item>

      <el-form-item prop="afm" :label="$t('afm')" v-show="false">
        <el-input v-model="userForm.afm" :disabled="true"></el-input>
      </el-form-item>

      <hr v-show="false" />

      <!-- ID Card/Passport - Compact Layout - Hidden for future use -->
      <el-form-item prop="id.idCardOrPassport" :label="$t('select')" class="compact-field" v-show="false">
        <el-radio-group v-model="idOrPassport" size="small" :disabled="true">
          <el-radio-button label="idCard">{{ $t('idcard') }}</el-radio-button>
          <el-radio-button label="passport">{{ $t('passport') }}</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        :label="$t('idnumber')"
        prop="id.number"
        class="compact-field"
        v-show="false"
      >
        <el-input
          v-model="userForm.id.number"
          :disabled="true"
          class="compact-input"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        v-show="false"
        prop="id.issueDate"
        :label="$t('dateofissue')"
        class="compact-field"
      >
        <el-input
          v-model="userForm.id.issueDate"
          :disabled="true"
          class="compact-input"
        ></el-input>
      </el-form-item>

      <el-form-item
        v-show="false"
        prop="id.expireDate"
        :label="$t('expirationdate')"
        class="compact-field"
      >
        <el-input
          v-model="userForm.id.expireDate"
          :disabled="true"
          class="compact-input"
        ></el-input>
      </el-form-item>

      <el-form-item
        v-show="false"
        prop="id.issueAuthority"
        :label="$t('depofissue')"
        class="compact-field"
      >
        <el-input
          v-model="userForm.id.issueAuthority"
          :disabled="true"
          class="compact-input"
        >
        </el-input>
      </el-form-item>

      <el-form-item
        v-show="false"
        prop="id.issueAuthority"
        :label="$t('countryofissue')"
        class="compact-field"
      >
        <el-input
          v-model="userForm.id.issueAuthority"
          :disabled="true"
          class="compact-input"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="savePersonalData">{{ $t('save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import config from '../config.js'
import sharedMethods from './common/sharedMethods.js'

export default {
  name: 'PersonalDataDialog',
  mixins: [sharedMethods],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    externalUserId: {
      type: String,
      required: false,
    },
    countries: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      userForm: {
        surname: '',
        name: '',
        fatherName: '',
        motherName: '',
        gender: '',
        birthCountryId: null,
        birthCity: '',
        dateOfBirth: '',
        countryId: null,
        address: '',
        city: '',
        area: '',
        postcode: '',
        telephone: '',
        mobile: '',
        email: '',
        afm: '',
        id: {
          idCardOrPassport: null,
          number: '',
          issueDate: '',
          expireDate: '',
          issueAuthority: '',
        },
      },
      genderOptions: [
        { value: 'ΑΝΤΡΑΣ', label: 'male' },
        { value: 'ΓΥΝΑΙΚΑ', label: 'female' },
        { value: 'ΑΛΛΟ', label: 'other_gender' },
      ],
      rules: {
        telephone: [
          {
            required: false,
            min: 10,
            max: 20,
            message: this.$t('numberValidationMsg'),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: this.$t('mobileRequiredMsg'),
            trigger: 'blur',
          },
          {
            min: 10,
            max: 20,
            message: this.$t('numberValidationMsg'),
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: this.$t('emailRequiredMsg'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('emailValidationMsg'),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    idOrPassport() {
      if (this.userForm.id.idCardOrPassport === null) {
        return 'idCard'
      }
      return this.userForm.id.idCardOrPassport ? 'idCard' : 'passport'
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadUserData()
      }
    },
  },
  methods: {
    loadUserData() {
      const applicationStr = sessionStorage.getItem('workingApplication')
      if (!applicationStr) {
        return
      }
      try {
        const application = JSON.parse(applicationStr)
        if (application && application.personalDetails) {
          const pd = application.personalDetails
          this.userForm = {
            surname: pd.surname || '',
            name: pd.name || '',
            fatherName: pd.fatherName || '',
            motherName: pd.motherName || '',
            gender: pd.gender || '',
            birthCountryId: pd.birthCountryId || null,
            birthCity: pd.birthCity || '',
            dateOfBirth: pd.dateOfBirth || '',
            countryId: pd.countryId || null,
            address: pd.address || '',
            city: pd.city || '',
            area: pd.area || '',
            postcode: pd.postcode || '',
            telephone: pd.telephone || '',
            mobile: pd.mobile || '',
            email: pd.email || '',
            afm: pd.afm || '',
            id: {
              idCardOrPassport: pd.id ? pd.id.idCardOrPassport : null,
              number: pd.id ? pd.id.number || '' : '',
              issueDate: pd.id ? pd.id.issueDate || '' : '',
              expireDate: pd.id ? pd.id.expireDate || '' : '',
              issueAuthority: pd.id ? pd.id.issueAuthority || '' : '',
            },
          }
        }
      } catch (error) {
        console.error('Error parsing workingApplication:', error)
      }
    },

    handleClose() {
      this.dialogVisible = false
    },

    savePersonalData() {
      this.$refs.personalDataForm.validate(valid => {
        if (valid) {
          this.loading = true

          const userId = JSON.parse(sessionStorage.getItem('externalUserId'))

          if (!userId) {
            this.$notify.error({
              title: this.$t('error'),
              message: 'External User ID not found'
            })
            this.loading = false
            return
          }

          const payload = {
            personalDetails: {
              countryId: this.userForm.countryId,
              address: this.userForm.address,
              city: this.userForm.city,
              area: this.userForm.area,
              postcode: this.userForm.postcode,
              telephone: this.userForm.telephone,
              mobile: this.userForm.mobile,
              email: this.userForm.email,
              dateOfBirth: this.userForm.dateOfBirth,
              birthCountryId: this.userForm.birthCountryId,
              birthCity: this.userForm.birthCity,
              gender: this.userForm.gender,
            },
          }

          axios.put(`${config.BASE_URL}/externalusers/${userId}/updateData`, payload)
            .then(response => {
              this.loading = false
              this.$notify({
                title: this.$t('success'),
                message: this.$t('personalDataUpdatedMsg'),
                type: 'success',
              })

              // Update sessionStorage with new contact information
              const application = JSON.parse(sessionStorage.getItem('workingApplication'))
              if (application && application.personalDetails) {
                application.personalDetails.telephone = this.userForm.telephone
                application.personalDetails.mobile = this.userForm.mobile
                application.personalDetails.email = this.userForm.email
                sessionStorage.setItem('workingApplication', JSON.stringify(application))
              }
              this.$emit('data-updated', response.data)
              this.handleClose()
            })
            .catch(err => {
              this.loading = false
              this.backendErrorNotify(err)
            })
        } else {
          this.$notify.warning({
            title: this.$t('warning'),
            message: this.$t('formValidationError'),
          })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '../styles/variables.scss';

.el-select {
  &.countries {
    width: 240px;
  }
}

.el-input {
  width: 240px;
}

// Compact layout for ID card/passport section
.compact-field {
  margin-right: 10px;

  .el-form-item__label {
    width: 100px !important;
    font-size: 13px;
  }

  .compact-input {
    width: 150px;
  }
}

// Fix for validation messages - prevents field shifting
::v-deep .el-form-item__error {
  position: absolute;
  top: 100%;
  left: 0;
  line-height: 1;
  padding-top: 2px;
}

::v-deep .el-form-item {
  margin-bottom: 30px; // Leave space for error messages
}

hr {
  border-color: #7da0b8;
  margin: 15px 0;
}
</style>
